import { withTranslation } from "react-i18next";

import React from 'react';
import { Footer } from '../Common/Footer';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../Common/DashboardHeader';
import Request from '../../Models/Request';
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios';
import { Header } from '../Common';
import { SideBar } from '../Common/SideBar';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
class RequestDetailsFromBulletin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            modal: false,
            categories: [],
            subCategories: [],
            category: '',
            sub_cat: '',
            request: '',
            requestAll: [],
            response_content: '',
            seller: '',
            date: '',
            budget: '',
            count: '',
            existing: [],
            visible: false
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        // console.log(this.props.location.state.id)
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        Request.getRequestDetail(this.props.location.state.id, this.props.location.state.user).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload })
                this.setState({ requestAll: res.data.requestall })
                this.setState({ count: res.data.count })
                this.setState({ existing: res.data.existing_response })
            }
        })
        // if (this.props.location.state.response_content != null) {
        //     this.setState({ existing: this.props.location.state });
        //     this.state.response_content = this.props.location.state.response_content
        //     this.state.budget = this.props.location.state.budget
        //     this.state.date = this.props.location.state.date

        // }
        // console.log(this.state.existing)
    }
    // componentWillMount() {
    //     Request.getRequestDetail(this.props.location.state.id, this.props.location.state.user).then(res => {
    //         if (res.data.payload != null) {
    //             this.setState({ request: res.data.payload })
    //             this.setState({ requestAll: res.data.requestall })
    //             this.setState({ count: res.data.count })
    //             this.setState({ existing: res.data.existing_response })
    //         }
    //     })
    // }
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {

            let a = this.state.request.budget_range.split('~')
            console.log(a)
            let i = parseInt(a[a.length - 1])
            console.log(i)
            let x = parseInt(a[a.length - 2])
            console.log(this.state.budget)
            if (this.state.budget >= x && this.state.budget <= i) {
                this.state.budget = this.state.budget;
            } else {
                alert(`※ ${this.props.t('0')} ${this.state.request.budget_range} ${this.props.t('21')}.`)
                return
            }
            var logged_user = JSON.parse(window.localStorage.getItem('info'));
            if (this.state.response_content == '' || this.state.response_content == null) {
                alert(this.props.t('2'));
                return;
            } else if (this.state.budget == '' || this.state.budget == null) {
                alert(this.props.t('6'));
                return;
            } else if (this.state.date == '' || this.state.date == null) {
                alert(this.props.t('7'));
                return;
            }
            let data = {
                'request_id': this.state.request.id,
                'seller_id': logged_user.id,
                'content': this.state.response_content,
                'estimated_price': this.state.budget,
                'estimated_deadline': this.state.date,
            }
            Request.saveRequestDetail(data).then(res => {
                if (res.data.status === 200) {
                    alert(this.props.t('3'))
                    console.log(res.data)
                    if (res.data.path === 'TRANSACTION') {
                        this.props.history.push( '/seller-estimate')
                    } else {
                        this.props.history.push( '/request-home')
                    }
                }
            })
                .catch(
                    console.log('asd')
                )
        } else {
            this.validator.showMessages();
        }
        // if (this.validator.allValid()) {
        //     this.props.history.push({
        //         pathname: `/request-details-confirm/${this.props.location.state.id}`,
        //         state: {
        //             user: this.props.location.state.user,
        //             id: this.props.location.state.id,
        //             response_content: this.state.response_content,
        //             date: this.state.date,
        //             budget: this.state.budget
        //         }
        //     })
        //     this.toggle()
        // } else {
        //     this.validator.showMessages();
        // }
    }

    validation() {
        // e.preventDefault()
        if (this.validator.allValid()) {
            let a = this.state.request.budget_range.split('~')
            let i = parseInt(a[a.length - 1])
            let x = parseInt(a[a.length - 2])
            if (this.state.budget >= x && this.state.budget <= i) {
                this.setState({ budget: this.state.budget })
            } else {
                this.setState({ budget: '' })
                return
            }
            console.log(this.state.budget)
            this.setState({
                response_content: this.state.response_content,
                date: this.state.date,
                // budget: this.state.budget
            })
            this.toggle();
        } else {
            this.validator.showMessages();
        }
    }

    errorMessage() {
        console.log(this.state.request.budget_range)
        if(this.state.request.length===0){
            return;
        } else {
            let a = this.state.request.budget_range.split('~')
            let i = parseInt(a[a.length - 1])
            let x = parseInt(a[a.length - 2])
            if (this.state.budget < x || this.state.budget > i) {
                return (
                    <div style={{ color: 'red', fontSize: '12px' }}>
                        <span>※ {this.props.t('0')} {this.state.request.budget_range} {this.props.t('21')}.</span>
                    </div>
                )
            }
            console.log(i)
        }



    }

    confirmation() {
        return (
            <div>
                <Button type="submit" onClick={this.validation.bind(this)} style={{ padding: "1%", borderRadius: "4px", backgroundColor: "#bdeab2", fontSize: "22px", borderColor: '#bdeab2' }}>{this.props.t('10')}</Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} className="modal-lg">
                    <ModalHeader toggle={this.toggle.bind(this)}></ModalHeader>
                    <ModalBody>
                        <div className="request">
                            {/* <div className="blank_div"></div> */}
                            <div className="mini_padding" style={{ height: "auto" }}>
                                <div className="row  px-3">
                                    <div className="mini_padding inner-div card" style={{ width: "100%", minHeight: "370px" }}>
                                        <div className=" row">
                                            <div className="col-md-2" style={{ textAlign: "center" }}>
                                                <img style={{ borderRadius: "50%", height: "60px" }} src={this.state.request.img} alt=""></img>&nbsp;&nbsp;
                                                        </div>
                                            <div className="col-md-10">
                                                <div style={{ fontSize: "11px" }}><span style={{ color: "#37c9dc" }}>{this.state.request.buyer_name}</span></div>
                                                <div style={{ fontSize: "22px" }}><b>{this.state.request.title}</b></div>
                                            </div>
                                        </div>
                                        <div className=" row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-7">
                                                <div style={{ fontSize: "11px" }}><span style={{ color: "#37c9dc" }}>{this.props.t('8')} : </span> {this.state.request.cat}</div>
                                                <div style={{ fontSize: "11px" }}>
                                                    <span style={{ color: "#37c9dc" }}>{this.props.t('11')} : </span> {this.state.request.application_date}&nbsp;
                                                                <span style={{ color: "#37c9dc" }}>{this.props.t('19')} : </span> {this.state.request.budget_range} {this.props.t('21')}
                                                            </div>
                                            </div>
                                            <div className="col-md-3">
                                            </div>
                                        </div>
                                        <div className=" row">&nbsp;</div>
                                        <div className="row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-10 card-text">
                                                {this.state.request.content}<br /><br />
                                                {/* ※ {this.props.t('4')}. */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mini_padding inner-div" style={{ width: "100%", height: "auto" }}>
                                        <div style={{ border: '1px solid #ccc' }}>
                                            <div id="floating_div" className="mini_padding inner-div" style={{ width: "100%", height: 'auto', display: "block", textAlign: "center" }}>
                                                <div className="row ml-3" >
                                                    <div className="col-md-8">
                                                        <div className="row">
                                                            <img style={{ borderRadius: "50%", height: "60px" }} src={this.state.request.img} alt=""></img>&nbsp;&nbsp;
                                                                    <div className="ml-5 mt-3">{this.state.request.buyer_name}</div>
                                                        </div>
                                                        <div className="mt-3">
                                                            {this.state.response_content}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div>
                                                            <h4>{this.state.budget}</h4>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                {this.props.t('11')}
                                                                    </div>
                                                            <div>
                                                                {this.state.date}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.toggle.bind(this)}>{this.props.t('13')}</Button>{' '}
                        <Button color="secondary" onClick={this.handleSubmit.bind(this)} >{this.props.t('14')}</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4 input_name">
                                <SideBar />
                            </div>
                            <div className="col-md-8">
                                    <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: '100%' }}>
                                        {this.props.t('15')}
                                    </div>
                                <div className="request">
                                    {/* <div className="blank_div"></div> */}
                                    <div className="mini_padding" style={{ height: "auto" }}>
                                        <div className="row  px-3">
                                            <div className="mini_padding inner-div card" style={{ width: "100%" }}>
                                                <div className=" row">
                                                    <div className="col-md-2" style={{ textAlign: "center" }}>
                                                        <img style={{ borderRadius: "50%", height: "60px" }} src={this.state.request.img} alt=""></img>&nbsp;&nbsp;
                                                        </div>
                                                    <div className="col-md-10">
                                                        <div style={{ fontSize: "11px" }}><span style={{ color: "#37c9dc" }}>{this.state.request.buyer_name}</span> </div>
                                                        <div style={{ fontSize: "22px" }}><b>{this.state.request.title}</b></div>
                                                    </div>
                                                </div>
                                                <div className=" row">
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-7">
                                                        <div style={{ fontSize: "11px" }}><span style={{ color: "#37c9dc" }}>{this.props.t('8')} : </span> {this.state.request.cat}</div>
                                                        <div style={{ fontSize: "11px" }}>
                                                            <span style={{ color: "#37c9dc" }}>{this.props.t('11')} : </span> {this.state.request.application_date}&nbsp;
                                                                <span style={{ color: "#37c9dc" }}>{this.props.t('19')} : </span> {this.state.request.budget_range} {this.props.t('21')}
                                                            </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                    </div>
                                                </div>
                                                <div className=" row">&nbsp;</div>
                                                <div className=" row">
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-10 card-text">
                                                        {this.state.request.content}<br /><br />
                                                        {/* ※ {this.props.t('4')}. */}
                                                    </div>
                                                </div>
                                            </div>
                                            {(() => {
                                                if (this.state.count !== 0) {
                                                        return (
                                                            <div style={{width: "100%"}}>
                                                                {this.state.existing.map(group =>
                                                                    <div id="floating_div" className="mini_padding inner-div" style={{ width: "100%", minHeight: "70px", display: "block", textAlign: "left" }}>
                                                                        <div className="row">
                                                                            <div className="col-md-2"></div>
                                                                            <div className="col-md-10">
                                                                                {group.content}
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-md-2"></div>
                                                                            <div className="col-md-10">
                                                                                {this.props.t('18')}: {group.estimated_price}
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-md-2"></div>
                                                                            <div className="col-md-10">
                                                                                {this.props.t('17')}: {group.estimated_deadline}
                                                                            </div>
                                                                        </div>
                                                                        <br/>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    }
                                                })()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* {/ {/ < div className="col-md-2"></div> /} /} */}
                        </div>
                    </div>
                </div>
                <Footer />
            </div >
        )
    }
}
export { RequestDetailsFromBulletin }


 RequestDetailsFromBulletin = withTranslation('src_Components_Request_RequestDetailsFromBulletin')(RequestDetailsFromBulletin);
